<!--
 * @Author: Victor victorqwer1234567890@gmail.com
 * @Date: 2023-12-22 23:53:33
 * @LastEditors: Merlin
 * @LastEditTime: 2024-08-21 17:53:24
 * @Description: 在特定币时变化图标 
-->
<template>
    <GameSettingsButtonWrapper
        :tool-tip="$t('waves.PriceFormulation')" 
        anchor="top middle"
        self="bottom middle"
        @click="jump2Formulation"
    >
        <IconSvgUse
            size="17px"
            use="formulas-icon"
        />
    </GameSettingsButtonWrapper>
</template>

<script setup lang="ts">
import {jump2Formulation } from '@/pages/casino/futuresGame/ts/wavesFn'; 

// const props = defineProps({
//     modelValue: { // 目前没有用到 
//         type: Boolean,
//         default: false,
//     },
// });


</script>

